import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";
import { WhatsAppContactType } from "@packages/chat-sdk";

export interface WhatsAppContactsPersistentStoreType {
  fromUserId?: string;
  userId?: string;
  contactType?: WhatsAppContactType;
}
export const whatsappContactsPersistentStore =
  new Store<WhatsAppContactsPersistentStoreType>(
    persist(
      () => ({
        fromUserId: undefined,
        userId: undefined,
        contactType: undefined,
      }),
      {
        name: storageKey.WHATSAPP_CONTACTS_STORAGE,
        storage: createJSONStorage(() => localStorage),
      }
    ) as any
  );

export const whatsappContactsPersistentStoreActions = {
  selectContact(payload: {
    fromUserId?: string;
    userId?: string;
    contactType?: WhatsAppContactType;
  }) {
    whatsappContactsPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.WHATSAPP_CONTACTS_STORAGE);
  },
};
